import {BlockEmbed} from "../blots/block";
import Image from "./image";
// import Quill from "../core/quill";
// import Keyboard from "../modules/keyboard";
import icons from '../ui/icons';

class Gallery extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode, images) {
    super(scroll, domNode);
    this.uploadingCount = 0;
    
    this.images = typeof images === 'object'
      ? Array.prototype.map.call(images, el => el.src ? el.src : el)
      : this.statics.value(domNode);
  
    this.editMode = this.images.length === 0;
  
    // this.domCursor = document.createElement('span');
    // this.domCursor.classList.add('cursor_wrapper');
    // this.domCursor.setAttribute('contenteditable', true);
    // this.domNode.appendChild(this.domCursor);
  
    // галерея
    const container = document.createElement('div');
    container.className = 'container-list';
    this.domNode.appendChild(container);
    
    this.grid = document.createElement('div');
    this.grid.className = 'flexbin flexbin-margin';
    container.appendChild(this.grid);
    
    // контейнер для режима редактирования
    const editContainer = document.createElement('div');
    editContainer.className = 'container-edit';
    this.domNode.appendChild(editContainer);
    
    const editButtons = document.createElement('div');
    editButtons.className = 'buttons';
    editButtons.innerText = 'Редактирование галереи';
    editContainer.appendChild(editButtons);
  
    // const btnCancel = document.createElement('button');
    // btnCancel.setAttribute('type', 'button');
    // btnCancel.innerText = 'Отмена';
    // btnCancel.addEventListener('click', this.changeMode.bind(this));
    // editButtons.appendChild(btnCancel);
    
    this.btnDestroy = document.createElement('button');
    this.btnDestroy.setAttribute('type', 'button');
    this.btnDestroy.innerText = 'Удалить';
    this.btnDestroy.addEventListener('click', this.remove.bind(this));
    editButtons.appendChild(this.btnDestroy);
    
    this.btnSave = document.createElement('button');
    this.btnSave.setAttribute('type', 'button');
    this.btnSave.innerText = 'Сохранить';
    this.btnSave.addEventListener('click', this.changeMode.bind(this));
    editButtons.appendChild(this.btnSave);
    
    this.editGrid = document.createElement('div');
    this.editGrid.className = 'images';
    editContainer.appendChild(this.editGrid);
    
    this.btnUploadContainer = document.createElement('span');
    const btnUploadWww = document.createElement('button');
    btnUploadWww.classList.add('link-button');
    btnUploadWww.innerHTML = icons.interfacePack.link;
    btnUploadWww.setAttribute('title', 'Указать ссылку на изображение');
    btnUploadWww.addEventListener('click', (e) => {
      e.preventDefault();
      const link = prompt('Введите ссылку на изображение');
      if (link !== null) {
        this.add(link);
      }
    });
    
    const btnUpload = document.createElement('span');
    btnUpload.className = 'btn-upload';
    btnUpload.innerText = 'Загрузить фото';
    btnUpload.addEventListener('click', this.handleImageBtnClick.bind(this));
  
    this.btnUploadContainer.appendChild(btnUpload);
    this.btnUploadContainer.appendChild(btnUploadWww);
  
    // кнопка переключения между режимами
    const btnMode = document.createElement('button');
    btnMode.setAttribute('type', 'button');
    btnMode.className = 'btn-mode';
    btnMode.innerText = 'Редактировать';
    btnMode.addEventListener('click', this.changeMode.bind(this));
    this.domNode.appendChild(btnMode);
    
    this.updateEditable();
  }
  
  // attach() {
  //   super.attach();
  //   this.quill = Quill.find(this.scroll.domNode.parentNode);
  //
  //   this.domCursor.addEventListener('keydown', (e) => {
  //     let key = e.which || e.keyCode;
  //     if (key === Keyboard.keys.BACKSPACE) {
  //       let offset = this.offset(this.quill.scroll);
  //       this.quill.deleteText(offset, this.length(), Quill.sources.USER);
  //       this.quill.setSelection(offset - 1, 0, Quill.sources.USER);
  //       e.preventDefault();
  //     } else if (key === Keyboard.keys.ENTER) {
  //       let index = this.offset(this.quill.scroll) + this.length();
  //       this.quill.focus();
  //       this.quill.insertText(index, '\n', Quill.sources.USER);
  //       this.quill.setSelection(index, 0, Quill.sources.USER);
  //       e.preventDefault();
  //     }
  //   });
  //
  //   this.domCursor.addEventListener('paste', (e) => {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   });
  // }
  
  changeMode() {
    this.editMode = !this.editMode;
    this.updateEditable();
  }
  
  updateGrid() {
    this.grid.innerHTML = '';
    this.images.map(src => {
      const img = document.createElement('img');
      const link = document.createElement('span');
      img.src = src;
      link.appendChild(img);
      this.grid.appendChild(link);
    });
  }
  
  onUploadStart() {
    this.uploadingCount++;
    this.refreshGrid();
  }
  
  onUploadSuccess() {
    this.uploadingCount--;
    this.refreshGrid();
  }
  
  updateEditGrid () {
    this.editGrid.innerHTML = '';
    this.images.map(src => {
      const span = document.createElement('span');
      span.style.backgroundImage = 'url('+src+')';
      span.style.backgroundSize = 'cover';
      this.editGrid.appendChild(span);
      
      const deleteBtn = document.createElement('button');
      deleteBtn.setAttribute('type', 'button');
      deleteBtn.textContent = '×';
      deleteBtn.className = 'btn-remove';
      deleteBtn.addEventListener('click', () => {
        const index = this.images.indexOf(src);
        this.images.splice(index, 1);
        this.updateEditGrid();
      });
      span.appendChild(deleteBtn);
    });
    if (this.uploadingCount) {
      const loadingSpan = document.createElement('span');
      loadingSpan.style.backgroundImage = 'url(https://i.gifer.com/HZEb.gif)';
      loadingSpan.style.backgroundSize = 'cover';
      for (let i=0; i<this.uploadingCount; i++) {
        this.editGrid.appendChild(loadingSpan);
      }
    }
    this.editGrid.appendChild(this.btnUploadContainer);
    
    if (this.images.length) {
      this.btnSave.style.display = 'block';
      this.btnDestroy.style.display = 'none';
    } else {
      this.btnSave.style.display = 'none';
      this.btnDestroy.style.display = 'block';
    }
  }
  
  refreshGrid() {
    if (this.editMode) {
      this.updateEditGrid();
    } else {
      this.updateGrid();
    }
  }
  
  updateEditable() {
    this.domNode.classList.toggle('edit', this.editMode);
    this.refreshGrid();
  }
  
  static value(domNode) {
    const nodes = domNode.querySelectorAll('img');
    return Array.prototype.map.call(nodes, el => el.src);
  }
  
  handleImageBtnClick(e) {
    e.preventDefault();
    const that = this;
    let fileInput = that.quill.container.querySelector('input.ql-image[type=file][data-status=ready]');
    if (fileInput === null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'image/gif, image/jpeg, image/jpg, image/png');
      fileInput.classList.add('ql-image');
      fileInput.addEventListener('change', () => {
        if (fileInput.files !== null && fileInput.files[0] !== null) {
          let file = fileInput.files[0];
          const embedButtons = this.quill.getModule('embedButtons');
          this.onUploadStart();
          embedButtons.uploadFileToCloud(file, xhr => {
            const json = JSON.parse(xhr.responseText);
            // const url = json.data['thumb'];
            this.onUploadSuccess();
            this.add(json.data['secure_url']);
          });
        }
      });
      this.quill.container.appendChild(fileInput);
    }
    fileInput.setAttribute('data-status', 'busy');
    fileInput.click();
  }
  
  add(src) {
    this.images.push(src);
    this.refreshGrid();
  }
  
  // update() {
  //   this.domCursor.innerHTML = '';
  // }
  
  // index() {
  //   return 0;
  // }
  
  // position() {
  //   return [this.domCursor, 0];
  // }
}

Gallery.blotName = 'gallery';
Gallery.tagName = 'DIV';
Gallery.className = 'gallery';

Gallery.allowedChildren = [Image];

export default Gallery;